var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-popover",
    {
      ref: "volumePopover",
      attrs: {
        placement: _vm.placement,
        popoverArrowClass: "hidden",
        popoverInnerClass: ["bg-transparent"],
        trigger: "click",
        offset: "15"
      }
    },
    [
      _c(
        "button",
        {
          staticClass: "block tooltip-target cursor-pointer",
          attrs: {
            title: _vm.$t(_vm.buttonTitle.key, _vm.buttonTitle.attr),
            "data-test": "volume-control"
          },
          on: { click: _vm.focus }
        },
        [
          _c("icon", {
            attrs: { "aria-hidden": "true", type: _vm.icon, color: _vm.color }
          })
        ],
        1
      ),
      _c("template", { slot: "popover" }, [
        _c(
          "div",
          {
            staticClass: "w-40 px-2 rounded shadow",
            style: { background: _vm.background, color: _vm.background }
          },
          [
            _c("input-slider", {
              ref: "volumeControl",
              staticClass: "mr-5",
              attrs: {
                tabindex: "0",
                "data-test": "volume-control--slider",
                min: 0,
                max: 100,
                value: _vm.volume * 100,
                step: 1,
                background: _vm.color,
                borderColor: _vm.color,
                progressColor: _vm.progressColor,
                "aria-label": _vm.$t(_vm.volumeLabel.key, _vm.volumeLabel.attr)
              },
              on: { input: _vm.setVolume }
            })
          ],
          1
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }